import { AbstractPmsApiService } from "./abstract.service";
import { SCTHApiSetting } from "../models";

/**
 * @class SCTHApiSettingPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<SCTHApiSetting>}
 */
export class SCTHApiSettingPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/scth-api-setting';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SCTHApiSetting}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SCTHApiSetting(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<SCTHApiSetting>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {SCTHApiSetting} settings
     * @returns {Promise.<SCTHApiSetting>}
     */
    save(property, settings) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, settings, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/scth-api-setting.service.js